module.exports = __webpack_public_path__ + "img/b1.787638f2.png";